<template>
    <div class="rounded-xl xl:rounded-5xl overflow-hidden">
        <swiper
            ref="swiper"
            class="swiper basic z-10 transition duration-300"
            :class="{ 'opacity-0': isLoading, 'opacity-100': ! isLoading }"
            @swiper="onSwiper"
            :slides-per-view="1"
            :space-between="16"
            :scrollbar="{ draggable: true }"
            :breakpoints="{
                320:  { slidesPerView: 1 },
                640:  { slidesPerView: 2 },
                768:  { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
            }"
            :grab-cursor="true"
            :loop="defaultOptions.loop"
            :resistance-ratio="0"
        >
            <swiper-slide class="swiper-slide relative" v-for="(slide, index) in swiperSlides">
                <component :is="this.slideType()" :slide="slide"></component>
            </swiper-slide>
        </swiper>
    </div>

    <div
        :class="[navButtonCSS(), { 'opacity-0 xl:-left-8 text-4xl': isLoading, 'opacity-100 left-3 xl:-left-11 text-6xl': ! isLoading, 'opacity-30' : isOnFirstSlide(), 'opacity-100 xl:hover:scale-125' : ! isOnFirstSlide() }]"
        @click="prevSlide()"
        v-show="showNavButtons"
    >
        <img
            width="32"
            height="32"
            class="bg-hh-grey-50 xl:bg-transparent rounded-full p-1 w-8 rotate-180"
            src="/assets/img/frontend-v3/icons/global/icon-right-angle-orange.svg"
            alt="previous"
        >
    </div>
    <div
        :class="[navButtonCSS(), { 'opacity-0 xl:-right-8 text-4xl': isLoading, 'opacity-100 right-0 xl:-right-14 text-6xl': ! isLoading, 'opacity-30' : isOnLastSlide(), 'opacity-100 xl:hover:scale-125' : ! isOnLastSlide() }]"
        @click="nextSlide()"
        v-show="showNavButtons"
    >
        <img
            width="32"
            height="32"
            class="bg-hh-grey-50 xl:bg-transparent rounded-full p-1 w-8"
            src="/assets/img/frontend-v3/icons/global/icon-right-angle-orange.svg"
            alt="next"
        >
    </div>
</template>

<script>
// :observer="true"
// :observeParents="true"

import { Swiper, SwiperSlide } from 'swiper/vue';

export default {

    name: 'SwiperBasic',

    props: ['reference', 'type', 'swiper-data', 'options'],

    components: {
        Swiper,
        SwiperSlide,
    },

    data() {
        return {
            isLoading: true,
            showNavButtons: true,
            swiperSlides: {},
            defaultOptions: {
                loop: true,
            },
        }
    },

    created() {
        this.swiperSlides = this.swiperData;

        this.handleOptions(this.options)
    },

    mounted() {
        this.$nextTick(() => {
            this.showNavButtons = this.showNav();
        })

        // Simulate data loading delay
        setTimeout(() => {
            this.stopLoading();
        }, 0); // Replace 2000 with actual API call or data fetching
    },

    methods: {

        handleOptions(options) {

            if (typeof options === 'undefined') {
                return;
            }

            //update any default options from the given options
            for (const key of Object.keys(this.defaultOptions)) {

                if (this.defaultOptions.hasOwnProperty(key)) {
                    this.defaultOptions[key] = options[key] ?? this.defaultOptions[key];
                }
            }
        },

        slideType() {
            return 'slide-' + this.type;
        },

        onSwiper(swiper) {
            this.swiper = swiper;
        },

        showNav() {
            return this.slidesPerView() < Object.keys(this.swiperSlides).length;
        },

        slidesPerView() {
            let slidesPerView = 1;

            const viewportWidth = window.innerWidth;

            if (viewportWidth >= 1024) {
                slidesPerView = 4;
            } else if (viewportWidth >= 768) {
                slidesPerView = 3;
            } else if (viewportWidth >= 640) {
                slidesPerView = 2;
            }

            return slidesPerView;
        },

        isOnFirstSlide() {
            return this.isLoading ? false : (this.swiper?.isBeginning ?? false);
        },

        isOnLastSlide() {
            return this.isLoading ? false : (this.swiper?.isEnd ?? false);
        },

        nextSlide() {
            this.swiper.slideNext();
        },

        prevSlide() {
            this.swiper.slidePrev();
        },

        stopLoading() {
            this.isLoading = false;
            const referenceLoader = document.querySelector('[data-loader-reference="' + this.reference + '"]');
            referenceLoader.classList.add('hidden');
        },

        navButtonCSS() {
            return 'inline-block absolute top-1/2 -translate-y-1/2 w-12 cursor-pointer select-none duration-300 z-10';
        }
    }
};
</script>
